module.exports = __webpack_public_path__ + "img/2022_S.f49b79d7.png";